import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

const ConversationsPage = () => (
  <div className="flex flex-col">
    <div className="p-4">
      <Typography.BodyMd>
        {t("support_widget.no_messages_found")}
      </Typography.BodyMd>
    </div>
  </div>
);

export default ConversationsPage;
